import { isAllowed } from '@edreamsodigeo/frontend-cmp-client';

export const LocalStorageUtils = {
    getJSON(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowed('localStorage', key) ? JSON.parse(localStorage.getItem(key)) : null;
        } catch (err) {
            return null;
        }
    },
    setJSON(key, value) {
        try {
            if (isAllowed('localStorage', key)) {
                localStorage.setItem(key, JSON.stringify(value)); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            // Ignore
        }
    },
    getValue(key) {
        try {
            // eslint-disable-next-line no-restricted-properties
            return isAllowed('localStorage', key) ? localStorage.getItem(key) : null;
        } catch (err) {
            console.error(err);
            return null;
        }
    },
    setValue(key, value) {
        try {
            if (isAllowed('localStorage', key)) {
                localStorage.setItem(key, value); // eslint-disable-line no-restricted-properties
            }
        } catch (err) {
            console.error(err);
        }
    }
};
